import { t } from 'i18next';

export type TDeviceStatus = 'Operação'|'Máquina desenergizada'|'Desinstalação forçada';
export type DeviceStatusKeys = keyof typeof DeviceStatus;

export enum DeviceStatus {
  OPERATION = 'Operação',
  MACHINE_WITHOUT_ENERGY = 'Máquina desenergizada',
  FORCED_UNINSTALL = 'Desinstalação forçada'
}

export const getDeviceStatusKey = (value: TDeviceStatus | null | undefined): DeviceStatusKeys | null => {
  if (!value) return null;
  const key = (Object.keys(DeviceStatus) as DeviceStatusKeys[]).find((k) => DeviceStatus[k] === value);
  return key ?? null;
};

export const DeviceStatusOpts = [
  { name: t('emOperacao'), value: 'OPERATION' },
  { name: t('desinstalacaoForcada'), value: 'FORCED_UNINSTALL' },
];

export const DeviceStatusAllOpts: { label: string; value: DeviceStatusKeys }[] = [
  { label: t('emOperacao'), value: 'OPERATION' },
  { label: t('maquinaDesernergizada'), value: 'MACHINE_WITHOUT_ENERGY' },
  { label: t('desinstalacaoForcada'), value: 'FORCED_UNINSTALL' },
];
